module.exports = __webpack_public_path__ + "static/media/smishing.454bbdc5.png";